export const chatUITabs = {
  macros: {
    tabName: 'Suggested Macros',
    activeSrc: '/images/chatUI/suggested-macros-icon-active.svg',
    inactiveSrc: '/images/chatUI/suggested-macros-icon-inactive.svg',
  },
  productRecs: {
    tabName: 'Product Recommendations',
    activeSrc: '/images/chatUI/product-recommendations-icon-active.svg',
    inactiveSrc: '/images/chatUI/product-recommendations-icon-inactive.svg',
  },
};

export const emptyTabImgData = {
  error: { src: 'images/chatUI/chat-ui-fetch-error.svg', alt: 'fetch data error' },
  empty: { src: 'images/chatUI/no-data-to-display.svg', alt: 'no data exists' },
};
